import { Component, Input, OnInit } from '@angular/core';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { DialogConfig } from '../dialog/dialog-config';
import { ResponsiveService } from '../../services/responsive.service';
import { Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-pratica-selection',
  templateUrl: './pratica-selection.component.html',
  styleUrls: ['./pratica-selection.component.css']
})
export class PraticaSelectionComponent implements OnInit {
  @Input() tipiPraticaOptions;
  urladdPratica: string = '/' + UrlSettingsCore.URL_MODULO_PRATICA_CREATE;
  constructor(
    public config: DialogConfig,
  ) { }

  ngOnInit(): void {}
}
